/**
 * Admin module API paths (relative to API base URL).
 *
 * Kept in its own module rather than added to `API_ENDPOINTS` so the admin
 * routes are only pulled into the bundle that imports them — the user-facing
 * web app never references this file. Same pattern as `groupsEndpoints.ts`.
 */
export const ADMIN_ENDPOINTS = {
  USER: {
    LIST: '/api/v1/Admin/User/List',
    ACTIVE_STATUS: '/api/v1/Admin/User/ActiveStatus',
    STATISTICS: '/api/v1/Admin/User/Statistics',
    SET_TEMPORARY_PASSWORD: '/api/v1/Admin/User/SetTemporaryPassword',
    BY_GUID: (userGuid: string) => `/api/v1/Admin/User/${userGuid}`,
  },
  ACCOUNT: {
    CREATE: '/api/v1/Admin/AdminAccount',
    LIST: '/api/v1/Admin/AdminAccount/List',
    ACTIVE_STATUS: '/api/v1/Admin/AdminAccount/ActiveStatus',
    BY_GUID: (userGuid: string) => `/api/v1/Admin/AdminAccount/${userGuid}`,
  },
  DASHBOARD: {
    METRICS: '/api/v1/Admin/AdminDashboard/GetDashboardNewMetrics',
    REPORTED_POSTS: '/api/v1/Admin/AdminDashboard/GetReportedPosts',
    BULK_UPDATE_REPORTED: '/api/v1/Admin/AdminDashboard/BulkUpdateReportedPostOrComment',
    BULK_UPDATE_POST: '/api/v1/Admin/AdminDashboard/BulkUpdatePost',
  },
  ERROR_LOG: {
    LIST: '/api/v1/Admin/ErrorLog/List',
  },
} as const;

export default ADMIN_ENDPOINTS;
